import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { IconComponent } from '@ui';
import { IndicatorState } from '../../../models/indicator.models';
import { IndicatorStates } from '../../../constants/indicators.constants';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';

@Component({
  selector: 'ui-status-update-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslocoDatePipe],
  template: `
    <div
      class="flex flex-row items-center justify-center"
      [class]="isDanger() ? 'gap-x-2' : 'gap-x-1'"
    >
      @if (timestamp()) {
        <ui-icon
          [icon]="isDisabled() ? 'icons:wifi-off' : 'wifi'"
          [class]="
            isDisabled()
              ? 'text-neutral-6'
              : isSignalHealthy()
                ? 'text-green'
                : 'text-red-400'
          "
        />
      }
      <span
        class="rounded-full border px-1 py-0.5 text-xs"
        [class]="stateClassMap[state()]"
      >
        {{
          timestamp()
            ? (timestamp()
              | translocoDate: { dateStyle: 'short', timeStyle: 'medium' })
            : '--'
        }}
      </span>
    </div>
  `,
})
export class StatusUpdateIndicatorComponent {
  state = input<IndicatorState>(IndicatorStates.Default);
  isSignalHealthy = input<boolean>(true);
  timestamp = input<any>();

  isDisabled = computed(() => this.state() === IndicatorStates.Disabled);
  isDanger = computed(() => this.state() === IndicatorStates.Danger);

  stateClassMap: Record<IndicatorState, string> = {
    active: 'border-transparent text-black',
    disabled: 'border-transparent text-neutral-6',
    danger: 'bg-red-2 border-red-4 text-black',
  };
}
